module.exports = __webpack_public_path__ + "media/images/products/products/ed4-9147774895ce7f1bf5cec0ba80b2c3de.jpg";